import React, { useCallback } from 'react';
import EventLabel from '../../../components/EventLabel/EventLabel';
import { useStore } from '../../../store/Store';
import DateListbox from './DateListbox';
import { toJS } from 'mobx';

function Search(props) {
  const {
    search,
    bookableDates,
    bookableRoomSizes,
    onRoomSizeChange,
    onCheckinDateChange,
    onCheckoutDateChange,
    roomCount,
    fetching,
    gapDates,
    selectedSizes,
    onRoomsCountChange,
    checkoutDate,
    checkinDate,
    lockStartDate,
    lockEndDate,
    hideStartDate,
    hideEndDate,
    oneSizePerSearch,
    hideRoomCountSelector,
  } = props;

  const activeButtonStyle = [...document.querySelector('#THISTOO')?.sheet?.rules]?.find(rule => rule.selectorText === 'button.cms-button')?.style;

  return (
    <div>
      <div className="pb-6">
        {(!hideStartDate || !hideStartDate) && (
          <div className="content-wrapper cms-question questionnaire-group mb-4 w-full" style={{ backgroundColor: 'inherit' }}>
            <label>
              <EventLabel name="WhenDoYouWannaStay" groupName="CMS.Hotel" />
            </label>
            <div className="w-full flex mt-4 flex-wrap">
              {!hideStartDate && (
                <div className="w-full md:w-fit flex flex-col gap-y-1">
                  <label className="mb-4">
                    <EventLabel name="CheckinDate" groupName="CMS.Hotel" />
                  </label>
                  <DateListbox
                    disabled={lockStartDate}
                    date={checkinDate}
                    onChange={onCheckinDateChange}
                    dates={bookableDates?.filter(date => +new Date(date) < +new Date(checkoutDate)).sort((a, b) => +new Date(a) - +new Date(b))}
                  />
                </div>
              )}
              {!hideStartDate && !hideEndDate && (
                <div className="hidden items-end md:flex  mb-2 mx-2 text-sm text-neutral-600 font-normal">
                  <EventLabel name="ToDateSpan" groupName="CMS.Hotel" />
                </div>
              )}
              {!hideEndDate && (
                <div className=" mt-4 md:mt-0 w-full md:w-fit flex flex-col gap-y-1">
                  <label className="mb-4">
                    <EventLabel name="CheckOutDate" groupName="CMS.Hotel" />
                  </label>
                  <DateListbox
                    disabled={lockEndDate}
                    date={checkoutDate}
                    onChange={onCheckoutDateChange}
                    dates={[
                      ...bookableDates?.filter(date => +new Date(date) > +new Date(checkinDate)),
                      ...[gapDates?.[+new Date(checkinDate)] ? gapDates?.[+new Date(checkinDate)] : null],
                    ].sort((a, b) => +new Date(a) - +new Date(b))}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        <div className="flex gap-x-8 mt-4">
          {bookableRoomSizes?.length > 1 && (
            <div className="group room-count flex flex-col gap-y-1">
              <label className="title">
                <EventLabel name="RoomSize" groupName="CMS.Hotel" />
              </label>
              <div className="input-row" style={{ marginTop: '5px' }}>
                {bookableRoomSizes?.map((size, i) => (
                  <button
                    key={i}
                    style={{
                      backgroundColor: selectedSizes.includes(size)
                        ? activeButtonStyle?.backgroundColor !== ''
                          ? activeButtonStyle?.backgroundColor
                          : '#cccccc'
                        : undefined,
                      width: 'auto',
                      color: selectedSizes.includes(size) ? activeButtonStyle?.color : undefined,
                    }}
                    onClick={() => {
                      if (oneSizePerSearch) {
                        onRoomSizeChange([size]);
                        return;
                      }
                      onRoomSizeChange(size);
                    }}
                  >
                    <EventLabel name={'RoomSize' + size} groupName="CMS.Hotel" />
                  </button>
                ))}
              </div>
            </div>
          )}
          {!hideRoomCountSelector && (
            <div className="group room-count">
              <label className="title">
                <EventLabel name="RoomsCount" groupName="CMS.Hotel" />
              </label>
              <div className="input-row">
                <IncrementalInput roomCount={roomCount} onRoomsCountChange={onRoomsCountChange} />
              </div>
            </div>
          )}
        </div>
        <div className="group" style={{ marginTop: 20 }}>
          <button
            disabled={fetching || !checkoutDate || !checkinDate || selectedSizes?.length === 0}
            className="cms-button hotel-search-btn text-sm"
            onClick={search}
          >
            {fetching ? <EventLabel name="Loading" groupName="CMS.Hotel" /> : <EventLabel name="Search" groupName="CMS.Hotel" />}
          </button>
        </div>
      </div>
    </div>
  );
}

function IncrementalInput({ roomCount, onRoomsCountChange }) {
  return (
    <div className="incremental-input">
      <button className="m-0" disabled={roomCount === 1} onClick={() => (roomCount > 1 ? onRoomsCountChange(roomCount - 1) : null)}>
        -
      </button>
      <span>{roomCount}</span>
      <button onClick={() => onRoomsCountChange(roomCount + 1)}>+</button>
    </div>
  );
}

export default Search;
